import {createQueryParameters, to_url} from "../_helpers/utils";
import {Api, apiFetch} from "../_helpers/api";
import {GeoState} from "../_definitions/styleteq";
import {SearchRoutes} from "../routes";
import User from "../_data/models/User";
import Conversation from "../_data/models/Conversation";
declare const fetch;

const ConversationRepository = {
    get: (page: number = null, perPage: number = 5) => {
        const query = createQueryParameters({page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, 'conversations') + query)
            .then(response => {
                return response.json();
            });
    }, 
    getMessages: (conversationId: number, page: number = null, perPage: number = 10) => {
        const query = createQueryParameters({page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, `conversations/${conversationId}/messages`) + query)
            .then(response => {
                return response.json();
            });
    },   
    getMessagesByRecipientId: (recipientId: number, page: number = null, perPage: number = 5) => {
        const query = createQueryParameters({recipient_id: recipientId, page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, `conversations/find_by_recipient`) + query)
            .then(response => {
                return response.json();
            });
    }, 
    sendMessage: (userId:number, conversationId: number, content:string, isNew:boolean) => {
        let data = new FormData();
        data.append('message[recipient_id]', '' + userId);
        data.append('message[content]', '' + content);
       
        const url = isNew ? 'messages' : `conversations/${conversationId}/reply`;

        return apiFetch(
            to_url(Api.apiBaseUrl, url),
            {method: 'POST', body: data}
        ).then(response => {
            return response.json();
        });
    }, 
    readMessage: (conversationId) => {
        return apiFetch(
            to_url(Api.apiBaseUrl, `conversations/${conversationId}/read`),
            {method: 'POST', data:{}}           
        ).then(response => {
             if (response.status >= 200 && response.status < 300) {
                return response;
            }
            else {
                return {
                    error: true,
                    response: response
                };
            }
        });
    }, 
};

export default ConversationRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/conversationRepository.ts